import {groupPipelineController} from './controller'

const groupPipeline = () => {
  return {
    restrict: 'AE',
    replace: true,
    scope: {
      groupList: '=',
      gridOptions: '=',
    },
    controller: groupPipelineController,
    template: require('./template.html'),
  }
}

angular.module('app.directives').directive('groupPipeline', groupPipeline)



// WEBPACK FOOTER //
// ./scripts/shared/directives/group-pipeline/directive.js